import { render, staticRenderFns } from "./tx-record.vue?vue&type=template&id=551120ec&"
import script from "./tx-record.vue?vue&type=script&lang=js&"
export * from "./tx-record.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports